import React from "react";

import styles from './CircleLoader.module.scss';

export default function CircleLoader() {
  return (
    <div className={styles.loaderContainer}>
      <svg
        className={styles.circleLoader}
        viewBox="0 0 80 80"
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          cx="40"
          cy="40"
          r="35"
          stroke="#257565"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
          strokeDasharray="55 220"
        />
      </svg>
    </div>
  );
}

